import Copy from '@resn/gozer-core/copy';
import { COLORS, DIR } from 'core/constants';
import { isMobile } from '@resn/gozer-env';

const device = isMobile ? 'mobile/' : '';

export default [
    {
        id: 'flex',
        title: Copy.get('xs1-configurator-packages-1-title'),
        desc: Copy.get('xs1-configurator-packages-1-description'),
        thumb: `${DIR.IMG}products/packages/thumb/${device}optimized/FLEX-optimized.png`,
        priceMonthly: Copy.get('xs1-product-module-8-price-month1'),
        available: true,
        mainColor: COLORS.LIGHT_BLUE,
    },
    {
        id: 'flow',
        title: Copy.get('xs1-configurator-packages-2-title'),
        desc: Copy.get('xs1-configurator-packages-2-description'),
        thumb: `${DIR.IMG}products/packages/thumb/${device}optimized/FLOW-optimized.png`,
        priceMonthly: Copy.get('xs1-product-module-8-price-month2'),
        available: true,
        mainColor: COLORS.LIGHT_BLUE,
    },

    {
        id: 'peak',
        title: Copy.get('xs1-configurator-packages-3-title'),
        desc: Copy.get('xs1-configurator-packages-3-description'),
        thumb: `${DIR.IMG}products/packages/thumb/${device}optimized/PEAK-optimized.png`,
        priceMonthly: Copy.get('xs1-product-module-8-price-month3'),
        available: true,
        mainColor: COLORS.VIOLET,
    },
    // REMOVED!!
    {
        id: 'form',
        title: Copy.get('xs1-configurator-packages-3-title'),
        desc: Copy.get('xs1-configurator-packages-3-description'),
        thumb: `${DIR.IMG}products/packages/thumb/${device}optimized/FORM-optimized.png`,
        priceMonthly: Copy.get('xs1-product-module-8-price-month3'),
        available: true,
        mainColor: COLORS.VIOLET,
    },
];
